import A11yNavigation from 'a11y-navigation'

const el = document.querySelector('.js-nav')

if (el) {
  // eslint-disable-next-line no-new
  new A11yNavigation({ el })
}
